/*
 * Copyright (c) 2005-2007, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: haxe.xml
 * class: Fast
 * root Object
 * @constructor
 */
haxe.xml.Fast = function(x) {
	if(x.nodeType != Xml.Document && x.nodeType != Xml.Element) throw "Invalid nodeType " + Std.string(x.nodeType);
	this.x = x;
	this.node = new haxe.xml._Fast.NodeAccess(x);
	this.nodes = new haxe.xml._Fast.NodeListAccess(x);
	this.att = new haxe.xml._Fast.AttribAccess(x);
	this.has = new haxe.xml._Fast.HasAttribAccess(x);
	this.hasNode = new haxe.xml._Fast.HasNodeAccess(x);
};
$hxClasses['haxe.xml.Fast'] = haxe.xml.Fast;
/** @private @type {Array} */
haxe.xml.Fast.__name__ = ["haxe","xml","Fast"];

/**
 * getElements
 *
 * $type TFun([],TAnonymous(<anonymous>))
 * function getElements()
 * @private
 * @this haxe.xml.Fast
 * @return {TAnonymous(<anonymous>)}
 */
haxe.xml.Fast.prototype.getElements = function() {
	/** @type {Iterator} */ 
	var it = this.x.elements();
	return { hasNext : $bind(it,it.hasNext), next : function() {
		/** @type {Xml} */ 
		var x = it.next();
		if(x == null) return null;
		return new haxe.xml.Fast(x);
	}};
};


/**
 * getInnerHTML
 *
 * $type TFun([],TInst(String,[]))
 * function getInnerHTML()
 * @private
 * @this haxe.xml.Fast
 * @return {string}
 */
haxe.xml.Fast.prototype.getInnerHTML = function() {
	/** @type {StringBuf} */ 
	var s = new StringBuf();
	var $it0 = this.x.iterator();
	while( $it0.hasNext() ) {
		var x = $it0.next();
		s.b += Std.string(x.toString());
	}
	return s.b;
};


/**
 * getInnerData
 *
 * $type TFun([],TInst(String,[]))
 * function getInnerData()
 * @private
 * @this haxe.xml.Fast
 * @return {string}
 */
haxe.xml.Fast.prototype.getInnerData = function() {
	/** @type {Iterator} */
	var it = this.x.iterator();
	if (!it.hasNext()) {
		throw this.getName() + " does not have data";
	}
	/** @type {Xml} */
	var v = it.next();
	/** @type {Xml} */
	var n = it.next();
	if(n != null) {
		/*  handle <spaces>CDATA<spaces> */
		if(v.nodeType == Xml.PCData && n.nodeType == Xml.CData && StringTools.trim(v.getNodeValue()) == "") {
			/** @type {Xml} */
			var n2 = it.next();
			if(n2 == null || n2.nodeType == Xml.PCData && StringTools.trim(n2.getNodeValue()) == "" && it.next() == null) return n.getNodeValue();
		}
		throw this.getName() + " does not only have data";
	}
	if(v.nodeType != Xml.PCData && v.nodeType != Xml.CData) throw this.getName() + " does not have data";
	return v.getNodeValue();
};


/**
 * getName
 *
 * $type TFun([],TInst(String,[]))
 * function getName()
 * @private
 * @this haxe.xml.Fast
 * @return {string}
 */
haxe.xml.Fast.prototype.getName = function() {
	return this.x.nodeType == Xml.Document?"Document":this.x.getNodeName();
};

/** @type {Iterator} */
haxe.xml.Fast.prototype.elements = null;
/** @type {haxe.xml._Fast.HasNodeAccess} */
haxe.xml.Fast.prototype.hasNode = null;
/** @type {haxe.xml._Fast.HasAttribAccess} */
haxe.xml.Fast.prototype.has = null;
/** @type {haxe.xml._Fast.AttribAccess} */
haxe.xml.Fast.prototype.att = null;
/** @type {haxe.xml._Fast.NodeListAccess} */
haxe.xml.Fast.prototype.nodes = null;
/** @type {haxe.xml._Fast.NodeAccess} */
haxe.xml.Fast.prototype.node = null;
/** @type {string} */
haxe.xml.Fast.prototype.innerHTML = null;
/** @type {string} */
haxe.xml.Fast.prototype.innerData = null;
/** @type {string} */
haxe.xml.Fast.prototype.name = null;
/** @type {Xml} */
haxe.xml.Fast.prototype.x = null;
/** @type {haxe.xml.Fast} */
haxe.xml.Fast.prototype.__class__ = haxe.xml.Fast;
